import React, { Component } from "react";

import styles from "./Teams.module.css";

import TeamsList from "./teamsList/TeamsList";
import PageHeader from "components/pageHeader/PageHeader";

import TextInput from "components/inputs/textInput/TextInput";

import * as Icons from "react-feather";
import { Link } from "react-router-dom";
import TeamsListData from "modules/api/apiModels/teamsListData";
import TeamMethods from "modules/api/teamMethods";

interface TeamsState {
  list?: TeamsListData;
  updatingList: boolean;
  message?: string;
  messageType?: "success" | "error";

  filter: string;
}

export default class Teams extends Component<{}, TeamsState> {
  constructor(props: {}) {
    super(props);

    const query = new URLSearchParams(window.location.search);

    const message = query.get("message");

    this.state = {
      updatingList: true,
      messageType: message === "team_success" ? "success" : undefined,
      message: message === "team_success" ? "Team created sucessfully." : undefined,
      filter: ""
    };

    this.setFilter = this.setFilter.bind(this);
    this.resetFilter = this.resetFilter.bind(this);
  }

  render() {
    return (
      <div className={styles.Teams}>
        {this.state.message && (
          <div className={styles.messageContainer}>
            {this.state.messageType === "success" && <div className={styles.messageSuccess}>{this.state.message}</div>}
          </div>
        )}
        <PageHeader title="Teams" spinner={this.state.updatingList ? "colorful" : undefined}>
          <TextInput
            placeholder="Filter"
            value={this.state.filter}
            type="text"
            icon={Icons.Search}
            onChange={this.setFilter}
          />
          <Link to="/app/teams/create" className={styles.addBtn}>
            Create Project
          </Link>
        </PageHeader>
        <div className={styles.projectsList}>
          {this.state.list && (
            <TeamsList filter={this.state.filter} items={this.state.list} onResetFilter={this.resetFilter}></TeamsList>
          )}
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.updateProjectList();
  }

  async updateProjectList() {
    this.setState({
      list: TeamMethods.getCachedTeamsList()
    });

    const list = await TeamMethods.getUserSubscribedTeams();

    this.setState({
      list: list,
      updatingList: false
    });
  }

  setFilter(v: string) {
    this.setState({
      filter: v
    });
  }

  resetFilter() {
    this.setState({
      filter: ""
    });
  }
}
